import { Injectable } from '@angular/core';
import * as signalR from "@aspnet/signalr"
import { AuthService } from './auth.service';
import { Observable, Subject } from 'rxjs';
import { MessageModel } from '../modules/maintenance.message/model/message.model';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private _updateUnreadNotificationsCountEvents: Subject<number> = new Subject();
  private _updateUnreadNotificationsCountEventsRegistered: boolean;
  private _maintenanceMessageEvents: Subject<CurrentMaintenanceMessage> = new Subject();
  private _maintenanceMessageEventsRegistered: boolean;
  private _kpiValuesEvents: Subject<number[]> = new Subject();
  private _kpiValuesEventsRegistered: boolean;

  private _connectionEvents: Subject<boolean> = new Subject();
  public get ConnectionEvents() : Observable<boolean> { return this._connectionEvents.asObservable(); }
  
  private _isConnected = false;
  public get IsConnected() { return this._isConnected; }

  private hubConnection: signalR.HubConnection;

  public startConnection = (authService: AuthService) => {
    if (!this.hubConnection) {
      this.hubConnection = new signalR.HubConnectionBuilder()
                              .withUrl('/hub/', { 
                                skipNegotiation: true, 
                                transport: signalR.HttpTransportType.WebSockets, 
                                accessTokenFactory: () => authService.oidcSecurityService.getToken()
                              })
                              .configureLogging(signalR.LogLevel.Error)
                              .build();
      this.hubConnection
        .start()
        .then(() => { this._isConnected = true; this._connectionEvents.next(this._isConnected); })
        .catch(err => { this._isConnected = false; this._connectionEvents.next(this._isConnected); console.log('Error while starting connection: ' + err); });

      this.hubConnection.onclose(function() {
        this._isConnected = false;
        this._connectionEvents.next(this._isConnected);
        setTimeout(function() { this.hubConnection = undefined; this.startConnection(authService); }, 5000);
      });
    }
  }

  public addUpdateUnreadNotificationsCountListener(): Observable<number> {
    if (!this._updateUnreadNotificationsCountEventsRegistered) {
      this.hubConnection.on('updateUnreadNotificationsCount', (data) => {
        this._updateUnreadNotificationsCountEvents.next(data);
      });

      this._updateUnreadNotificationsCountEventsRegistered = true;
    }

    return this._updateUnreadNotificationsCountEvents.asObservable();
  }

  public addPublishCurrentMaintenanceMessageListener(): Observable<CurrentMaintenanceMessage> {
    if (!this._maintenanceMessageEventsRegistered) {
      this.hubConnection.on('publishCurrentMaintenanceMessage', (data) => {
        this._maintenanceMessageEvents.next(data);
      });

      this._maintenanceMessageEventsRegistered = true;  
    }

    return this._maintenanceMessageEvents.asObservable();
  }

  public addPublishKpiValuesListener(): Observable<number[]> {
    if (!this._kpiValuesEventsRegistered) {
      this.hubConnection.on('publishKpiValues', (data) => {
        this._kpiValuesEvents.next(data);
      });
      
      this._kpiValuesEventsRegistered = true;  

      this.hubConnection.invoke("requestKpiValues");
    }

    return this._kpiValuesEvents.asObservable();
  }
}

export class CurrentMaintenanceMessage
{
    upcomingMessage: MessageModel;
    upcomingMessageMinutesUntil: number;
    activeMessage: MessageModel;
    activeMessageMinutesUntil: number;
} 


// WEBPACK FOOTER //
// ./src/app/services/signalr.service.ts